import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type User = {
  email: string;
  firstName: string;
  lastName: string;
  picture?: string;
};

type UserStore = {
  token: string;
  user: User | null;
  setUser: (user: User | null) => void;
  setToken: (token: string) => void;
  clearToken: () => void;
};

const useUserStore = create<UserStore>()(
  persist(
    (set) => ({
      token: '',
      user: null,
      setUser: (user) => {
        set({ user });
      },
      setToken: (token) => set({ token }),
      clearToken: () => set({ token: '' }),
    }),
    {
      name: 'user-storage',
    },
  ),
);

export type { User };
export default useUserStore;
